var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cls from 'classnames';
export function IconTile(_a) {
    var { icon, spin, className, onClick } = _a, props = __rest(_a, ["icon", "spin", "className", "onClick"]);
    const finalClassName = cls('WhSearch-IconTile', className);
    const click = (event) => {
        event.preventDefault();
        if (onClick) {
            onClick();
        }
    };
    return (React.createElement("div", Object.assign({ className: finalClassName, onClick: click }, props),
        React.createElement(FontAwesomeIcon, { icon: icon, spin: spin })));
}
//# sourceMappingURL=IconTile.js.map